import GigStartConfirmModal from './GigStartConfirmModal'
import { setToLive } from '../../dataStore/actions/gig/gigActions'
import { connect } from 'react-redux'
import { State } from '../../dataStore/reducers/reducerType'
import { closeGigStartConfirmationModal } from '../../dataStore/actions/ui/uiActions'

const mapStateToProps = (state: State) => ({
  isLiveReady: state.ui.isLiveReady,
  isOpen: state.ui.showGigStartConfirmationModal
})

const mapDispatchToProps = dispatch => ({
  onCancel: () => dispatch(closeGigStartConfirmationModal()),
  onConfirm: () => dispatch(setToLive())
})

export default connect(mapStateToProps, mapDispatchToProps)(GigStartConfirmModal)
